import React, { createContext, useContext } from 'react';

const SuspensionContext = createContext({ isSuspended: false });

export const SuspensionProvider = ({ isSuspended, children }) => (
  <SuspensionContext.Provider value={{ isSuspended: !!isSuspended }}>
    {children}
  </SuspensionContext.Provider>
);

export const useSuspension = () => useContext(SuspensionContext);
